export default {
  "content": "<path clip-rule=\"evenodd\" d=\"M2.707 1.293a1 1 0 00-1.414 1.414l12 12a1 1 0 001.414-1.414zM8 2a1 1 0 000 2h6v2h-2.5a1 1 0 100 2H14v2a1 1 0 102 0V4a2 2 0 00-2-2zM2 6a1 1 0 00-2 0v6a2 2 0 002 2h6a1 1 0 100-2H2V8a1 1 0 000-2z\" fill=\"#ff00cb\" fill-rule=\"evenodd\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "fill": "none",
    "height": "16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};